import { AxiosClient } from '@/app/shared/services';

const state = {
    accountsList: {
        list: [],
        isLoading: false,
    },
    currentAccount: {
        account: {
            name: '',
            api_key: '',
        },
        isLoading: false,
    },
};

const getters = {
    MAILING_ACCOUNTS_LOADING: (state) => state.accountsList.isLoading,
    MAILING_ACCOUNTS_LIST: (state) => state.accountsList.list,

    CURRENT_MAILING_ACCOUNT: (state) => state.currentAccount.account,
    CURRENT_MAILING_ACCOUNT_LOADING: (state) => state.currentAccount.isLoading,
};

const mutations = {
    SET_MAILING_ACCOUNT_LIST: (state, account_mailers) => {
        state.accountsList.list = account_mailers;
    },
    SET_MAILING_ACCOUNT_LOADING: (state, isLoading) => {
        state.accountsList.isLoading = isLoading;
    },
    SET_CURRENT_MAILING_ACCOUNT: (state, account_mailer) => {
        state.currentAccount.account = account_mailer;
    },
    SET_CURRENT_MAILING_ACCOUNT_LOADING: (state, isLoading) => {
        state.currentAccount.isLoading = isLoading;
    },
    SET_CURRENT_MAILING_ACCOUNT_DEFAULT: (state) => {
        state.currentAccount.account = {
            name: '',
            api_key: '',
        };
    },
};

const actions = {
    GET_MAILING_ACCOUNT_LIST: (context, params) => {
        context.commit('SET_MAILING_ACCOUNT_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/account_mailer/get', {params})
                .then((response) => {
                    context.commit('SET_MAILING_ACCOUNT_LIST', response.data);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit('SET_MAILING_ACCOUNT_LOADING', false);
                    context.commit("SET_CURRENT_MAILING_ACCOUNT_DEFAULT");
                });
        });
    },

    GET_MAILING_ACCOUNT_BY_ID: (context, mailing_account_id) => {
        context.commit('SET_CURRENT_MAILING_ACCOUNT_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/account_mailer/get/${mailing_account_id}`)
                .then((response) => {
                    context.commit('SET_CURRENT_MAILING_ACCOUNT', response.data);
                    resolve(response.data);
                })
                .catch(() => reject())
                .finally(() => context.commit('SET_CURRENT_MAILING_ACCOUNT_LOADING', false));
        });
    },

    UPDATE_MAILING_ACCOUNT: (context, account_mailer) => {
        context.commit("SET_CURRENT_MAILING_ACCOUNT_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/account_mailer/update/${account_mailer.id}`, account_mailer)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_MAILING_ACCOUNT_LOADING", false);
                    context.commit("SET_CURRENT_MAILING_ACCOUNT_DEFAULT");
                });
        });
    },

    CREATE_MAILING_ACCOUNT: (context, account_mailer) => {
        context.commit("SET_CURRENT_MAILING_ACCOUNT_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/account_mailer/create", account_mailer)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_MAILING_ACCOUNT_LOADING", false)
                    context.commit("SET_CURRENT_MAILING_ACCOUNT_DEFAULT")
                });
        });
    },

    DELETE_MAILING_ACCOUNT: (context, mailing_account_id) => {
        context.commit("SET_MAILING_ACCOUNT_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/account_mailer/delete/${mailing_account_id}`)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => context.commit("SET_MAILING_ACCOUNT_LOADING", false));
        });
    },


    SET_IS_USED_MAILING_ACCOUNT: (context, mailing_account_id) => {
        context.commit("SET_MAILING_ACCOUNT_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/account_mailer/set_is_used/${mailing_account_id}`)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => context.commit("SET_MAILING_ACCOUNT_LOADING", false));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
